import styled from '@emotion/styled';

import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const MainTextStyled = styled.p`
  margin: 0;
  max-width: 770px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  ${getMediaqueryStyled('xl')} {
    max-width: 590px;
  }

  ${getMediaqueryStyled('lg')} {
    max-width: 400px;
  }

  ${getMediaqueryStyled('md')} {
    max-width: none;
  }
`;

export const TextPenOutline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 116px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 75px;
  }

  ${getMediaqueryStyled('md')} {
    width: 102px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const TextPenUnderlineSmall = styled(PenLine)`
  display: none;

  ${getMediaqueryStyled('sm')} {
    display: block;
    width: 91px;
  }
`;

export const TextPenUnderlineFirst = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 174px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 122px;
  }

  ${getMediaqueryStyled('md')} {
    width: 160px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;

export const TextPenUnderlineSecond = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 250px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 178px;
  }

  ${getMediaqueryStyled('md')} {
    width: 237px;
  }
`;
